import React, {useEffect} from 'react'
import {Col, Row} from 'styled-bootstrap-grid'

import {useUser} from 'src/context/UserContext'

import type {CheckoutStep} from 'src/components/checkout'
import {CheckoutStatusBar, EmptyCart} from 'src/components/checkout'

import {BlockTitle, SpacingWrapper} from 'src/components/layout'
import {useCheckout} from 'src/context/CheckoutContext'
import {useRouter} from 'next/router'
import {paths} from 'src/utils/paths'
import CartOverview from '../cart/CartOverview'

interface Props {
  step: CheckoutStep
  children: React.ReactNode
  title?: string
  paymentInProgress?: boolean
}

export default function CheckoutPageWrapper({
  step,
  children,
  title,
  paymentInProgress,
}: Props): JSX.Element | null {
  const {user, showLogin} = useUser()
  const {checkout, checkoutLoading} = useCheckout()
  const router = useRouter()
  useEffect(() => {
    if (!user && showLogin) {
      router.replace(paths.cart)
    }
  }, [router, showLogin, user])
  if (!checkoutLoading && !checkout?.lines?.length && !paymentInProgress) {
    return <EmptyCart inCheckout />
  }
  if (!user) {
    return null
  }

  return (
    <>
      <CheckoutStatusBar step={step} />
      <SpacingWrapper spacing={50}>
        <BlockTitle title={title ?? ''} />
        <Row justifyContent="between">
          <Col col={12} md={7} lg={6}>
            {children}
          </Col>
          {!checkoutLoading && !!checkout?.lines?.length && (
            <Col col={12} md={4} lg={3}>
              <CartOverview />
            </Col>
          )}
        </Row>
      </SpacingWrapper>
    </>
  )
}
